import { combineReducers } from 'redux'
import {reducers as LoginReducer} from './Login'
import {reducers as searchResultReducer} from './SearchResult'

const rootReducer = combineReducers({
    LoginReducer,
    searchResultReducer
})

export default rootReducer